/* eslint-disable no-mixed-spaces-and-tabs,no-tabs,@typescript-eslint/no-unused-vars */

xplenty.directive('selectOutputSchema', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./select-output-schema.html'),

      replace: true,

      scope: {
        component: '=',
      },

      link(scope, element, attrs) {},
    };
  },
]);
